export default {
  companyFeedSettingsMetadata: {
    successSet: 'The list of questions for the feed was successfully saved',
    errorGet: 'Failed to get the list of questions for the feed',
    errorSet: 'Failed to save list of questions for feed',
    noFeedSettings:
      'No questions have been added to the feed yet. To add a question, create a survey on the «Surveys» tab and add a question to it with the «display in the feed» setting enabled',
    creationDate: 'Сreation date',
    nameQuestion: 'Question title',
    surveyDate: 'Survey date',
    deleteQuestionsButton: 'Delete selected questions from the feed',
    deleteQuestionsTitle: 'Delete questions from feed?',
    deleteQuestionsText: 'It will be impossible to cancel this action',
    successDeleteQuestions: 'The questions successfully deleted',
    errorDeleteQuestions: 'Failed to delete the questions',
  },
};
